"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var enquiryFromWebEnquiryTemplate = "\n<div class=\"ui-notification\">\n  <h3>New Enquiry Received</h3>\n  <div class=\"message\">\n    You have been assigned a new Web Enquiry by {{sender}}\n    <br />  \n\n    <a class=\"btn btn-success\" ui-sref=\"enquiryEdit({enquiryId: {{enquiryId}}})\">View</a>\n  </div>\n</div>\n";

exports.default = enquiryFromWebEnquiryTemplate;


// WEBPACK FOOTER //
// ./client/app/common/templates/notification/enquiryFromWebEnquiryTemplate.js